import apiUrl from '../../../../../utils/settings';

export const LinkedManufacturesUrl = () => {
  return apiUrl + '/benefits-v2/active-manufacturer-companies';
};
export const OverviewDetailsUrl = () => {
  return apiUrl + '/benefits-v2/humbee-benefits';
};

export const MyBenefitsUrl = () => {
  return apiUrl + '/benefits-v2/my-benefits-overview';
};
export const BenefitDetailUrl = () => {
  return apiUrl + '/benefits-v2/my-benefit-details';
};
export const GAPDetailUrl = () => {
  return apiUrl + '/benefits-v2/my-gap-benefit';
};
export const StaffDetailUrl = () => {
  return apiUrl + '/benefits-v2/staff-insurance-details';
};
export const ShopInsuranceDetailUrl = () => {
  return apiUrl + '/benefits-v2/shop-insurance-policy-details';
};
export const TDSDetailUrl = () => {
  return apiUrl + '/benefits-v2/cumulative-tds';
};
export const BenefitInsuraceCardUrl = () => {
  return apiUrl + '/benefits-v2/insurance-card';
};
export const ShopInsuranceCardUrl = () => {
  return apiUrl + '/benefits-v2/shop-insurance-card';
};
export const staffInsuranceCardUrl = () => {
  return apiUrl + '/benefits-v2/staff-insurance-card';
};
export const BenefitInsuracePolicyCardUrl = () => {
  return apiUrl + '/benefits-v2/policy-document';
};
export const BenefitHospitalNetworkUrl = () => {
  return apiUrl + '/benefits-v2/hospital-network';
};
export const DownloadCertificateURL = () => {
  return apiUrl + '/benefits-v2/tds-certificate';
};
export const DownloadNpsTransactionStatementUrl = () => {
  return apiUrl + '/benefits-v2/nps-transaction-statement';
};


